import { AfterViewInit, Component, signal, ViewChild } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { finalize, forkJoin, map, Observable } from 'rxjs';
import { ProgressBarOverlayComponent } from 'src/app/components/progress-bar-overlay/progress-bar-overlay.component';
import {
  CfgStampa,
  ConfigStampeService,
  TipoQuestionario,
} from 'src/app/services/config-stampe/config-stampe.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-cfg-linee-guida-stampe',
  templateUrl: './cfg-linee-guida-stampe.component.html',
  styleUrls: ['./cfg-linee-guida-stampe.component.scss'],
  standalone: false,
})
export class CfgLineeGuidaStampeComponent implements AfterViewInit {
  public isDatiLoaded = signal<boolean>(false);
  public tags = [
    {
      nome: 'Rag.Sociale Azienda',
      tag: 'azienda',
    },
    {
      nome: 'Nome destinatario',
      tag: 'nome_dest',
    },
    {
      nome: 'Titolo contesto',
      tag: 'titilo',
    },
  ];

  public removePlugins = [
    'BlockQuote',
    'FontBackgroundColor',
    'FontColor',
    'FontSize',
    'Indent',
    'IndentBlock',
    'Link',
    'PasteFromOffice',
    'Style',
    'Table',
    'TableToolbar',
    'TextTransformation',
  ];

  private _contesti: {
    tipo: TipoQuestionario;
    label: string;
    config: CfgStampa[];
    mailInvio: string;
    mailNotifica: string;
    landingPage: string;
  }[] = [
    {
      tipo: 'POLICY',
      label: 'Policy',
      config: [],
      mailInvio: '',
      mailNotifica: '',
      landingPage: '',
    },
    {
      tipo: 'BILANCIO',
      label: 'Report',
      config: [],
      mailInvio: '',
      mailNotifica: '',
      landingPage: '',
    },
    {
      tipo: 'SINTESI',
      label: 'Sintesi',
      config: [],
      mailInvio: '',
      mailNotifica: '',
      landingPage: '',
    },
    {
      tipo: 'SURVEY',
      label: 'Survey',
      config: [],
      mailInvio: '',
      mailNotifica: '',
      landingPage: '',
    },
    {
      tipo: 'PIANO',
      label: 'Piano',
      config: [],
      mailInvio: '',
      mailNotifica: '',
      landingPage: '',
    },
    {
      tipo: 'BILANCIOGO',
      label: 'Report Tematico',
      config: [],
      mailInvio: '',
      mailNotifica: '',
      landingPage: '',
    },
    {
      tipo: 'REPORT_VSME',
      label: 'Report VSME',
      config: [],
      mailInvio: '',
      mailNotifica: '',
      landingPage: '',
    },
    {
      tipo: 'AUTOVALUTAZIONE',
      label: 'Assessment',
      config: [],
      mailInvio: '',
      mailNotifica: '',
      landingPage: '',
    },
    {
      tipo: 'VALIDAZIONEIRO',
      label: 'Validazione IRO',
      config: [],
      mailInvio: '',
      mailNotifica: '',
      landingPage: '',
    },
    {
      tipo: 'DOPPIASURVEY',
      label: 'Survey Doppia Mat.',
      config: [],
      mailInvio: '',
      mailNotifica: '',
      landingPage: '',
    },
  ];

  get contesti() {
    return this._contesti;
  }

  @ViewChild(ProgressBarOverlayComponent) progressBarOverlay!: ProgressBarOverlayComponent;
  @ViewChild('scrollConfStampa') scrollConfStampa!: NgScrollbar;
  @ViewChild('scrollConfMail') scrollConfMail!: NgScrollbar;

  public salvataggioInCorso: { [key: string]: boolean } = {};

  constructor(
    private readonly utilityService: UtilityService,
    private readonly utility: UtilityService,
    private readonly configStampeService: ConfigStampeService,
  ) {}

  ngAfterViewInit() {
    this.isDatiLoaded.set(false);
    this.progressBarOverlay.show('Caricamento linee guida stampe e template mail...');
    const obsObj: { [key: string]: Observable<boolean> } = {};

    this._contesti.forEach((val) => {
      obsObj[val.tipo] = this.caricaLineeGuidaContesto(val.tipo);
    });

    forkJoin(obsObj)
      .pipe(
        finalize(() => {
          this.isDatiLoaded.set(true);
          this.progressBarOverlay.hide();
        }),
      )
      .subscribe({
        next: (result) => {
          const esito = Object.keys(result)
            .map((key) => result[key])
            .every((val) => val === true);

          if (esito) {
          } else {
            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: 'Non è stato possibile recuperare le linee guida.',
              bottoni: [{ nome_btn: 'Ok' }],
            });
          }
        },
        error: (err) => {
          console.error('errore get config stampe', err);

          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Non è stato possibile recuperare le linee guida.',
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
  }

  caricaLineeGuidaContesto(contesto: TipoQuestionario): Observable<boolean> {
    return this.configStampeService.getLineeGuida(contesto).pipe(
      map((result) => {
        const cfg = this._contesti.find((dati) => dati.tipo === contesto);

        if (cfg) {
          cfg.config = result?.cfgStampa;
          cfg.mailInvio = result?.mailInvio;
          cfg.mailNotifica = result?.mailNotifica;
          cfg.landingPage = result?.landingPage;
        }

        setTimeout(() => {
          this.scrollConfStampa.update();
          this.scrollConfMail.update();
        }, 0);

        return true;
      }),
    );
  }

  /**
   * Metodo che mi ordina la visualizzazione degli header drag and drop, e l'index dell'oggetto spostato
   * @param event
   */
  dropCfgStampa(event: any) {
    /* if (this.indicePolicy) {
      moveItemInArray(this.indicePolicy, event.previousIndex, event.currentIndex);

      if (event.previousIndex === this.indicePanel) {
        this.indicePanel = event.currentIndex;
      }

      // Aggiorna gli indici di tutti gli elementi nella lista
      this.indicePolicy.forEach((obj, index) => {
        obj.index = index;
      });

    } */
  }

  openGroup(event: any) {
    /* if (this.indicePolicy) {
      this.indicePanel = event.index;
    } */
  }

  salva(contesto: TipoQuestionario, cfg: CfgStampa) {
    this.salvataggioInCorso[cfg.chiave] = true;

    return this.configStampeService.salvaLineaGuida(cfg, contesto).subscribe({
      next: (result) => {
        this.utilityService.openSnackBar('Salvataggio effettuato', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });

        this.salvataggioInCorso[cfg.chiave] = false;
      },
      error: (err) => {
        this.utilityService.openDialog({
          titolo: 'Attenzione',
          descrizione: 'Non è stato possibile salvare la linea guida.',
          bottoni: [{ nome_btn: 'Ok' }],
        });

        this.salvataggioInCorso[cfg.chiave] = false;
      },
    });
  }

  salvaCfgMail(
    contesto: TipoQuestionario,
    mailNotifica: string,
    mailInvio: string,
    landingPage: string,
  ) {
    return this.configStampeService
      .salvaTemplateMail(mailNotifica, mailInvio, landingPage, contesto)
      .subscribe({
        next: (result) => {
          this.utilityService.openSnackBar('Salvataggio effettuato', '', {
            duration: 2000,
            panelClass: ['success-snackbar'],
          });
        },
        error: (err) => {
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Non è stato possibile salvare i template mail.',
            bottoni: [{ nome_btn: 'Ok' }],
          });

          /*    this.salvataggioInCorso[cfg.chiave] = false; */
        },
      });
  }

  async copiaTag(tag: string) {
    await navigator.clipboard.writeText('{{' + tag + '}}');

    this.utility.openSnackBar('Tag copiato!', '', {
      duration: 3000,
      panelClass: ['success-snackbar'],
    });
  }
}
